import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M50.5103 15.5465C42.025 0.947008 29.0195 1.44462 28.1075 1.50433C27.1956 1.56404 14.2297 0.947008 5.7048 15.5465C-1.95773 28.7228 1.21434 58.5387 6.08149 68.192C11.4046 78.761 21.6643 87.4888 28.1075 87.4888C34.5508 87.4888 44.8105 78.761 50.1435 68.192C55.0106 58.4989 58.143 28.683 50.5103 15.5465Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
